import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { profileMonthNames, toMonthInputValue } from '@/lib/profile-dates';

interface MonthYearSelectProps {
  value?: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 1949 + 6 }, (_, index) => String(currentYear + 5 - index));

const MonthYearSelect: React.FC<MonthYearSelectProps> = ({ value, onChange, disabled }) => {
  const monthValue = toMonthInputValue(value);
  const [selectedYear, selectedMonth] = monthValue.split('-');

  const updateValue = (year: string, month: string) => {
    if (!year || !month) return;
    onChange(`${year}-${month}`);
  };

  return (
    <div className="grid grid-cols-2 gap-2">
      <Select
        value={selectedMonth || undefined}
        onValueChange={(month) => updateValue(selectedYear || String(currentYear), month)}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder="Month" />
        </SelectTrigger>
        <SelectContent>
          {profileMonthNames.map((month, index) => {
            const value = String(index + 1).padStart(2, '0');
            return (
              <SelectItem key={value} value={value}>
                {month}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      <Select
        value={selectedYear || undefined}
        onValueChange={(year) => updateValue(year, selectedMonth || '01')}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder="Year" />
        </SelectTrigger>
        <SelectContent>
          {years.map((year) => (
            <SelectItem key={year} value={year}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default MonthYearSelect;
